import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PrintData from "components/GenericComponent/PrintData";
import {PrintDataContent} from "../../../../components/GenericComponent/PrintDataContent";
import configs from "constants/configs";
import { Cookies } from "react-cookie";
export const BtnInDanhSach = () => {
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiHopDong
  );
  const cookies = new Cookies();
  let link = configs.endPoint;
  var apilink = cookies.get("apilink");
  if (typeof apilink != "undefined" && apilink.length > 0) {
    link = apilink;
  }
  link = link +
    `thu-chi-hop-dong/in-danh-sach-thu-chi-hop-dong-data?tungay=${dataSearch.tuNgay}&denngay=${dataSearch.denNgay}&ten=${dataSearch.ten}&nhanvien=${dataSearch.nhanvien}&kieuvay=${dataSearch.kieuvay}&loaithuchi=${dataSearch.loaithuchi}&kenhthanhtoan=${dataSearch.kenhthanhtoan}&tinhtrangno=${dataSearch.tinhtrangno}`;
  return (
    <>
      <PrintDataContent link={link} loai={"ThuChiHopDongPrint"} />
    </>
  );
};
